import { useEffect, useState } from 'react';
import './index.css'
import { CircleCheckIcon, CircleErrorIcon, EyeClosedIcon, EyeOpenIcon } from '../Icons';

interface InputPasswordProps {
  label: string,
  name?: string,
  value: any,
  onChange?: (event: any) => void,
  showEye?: boolean,
  disabled?: boolean
}

const InputPassword = ({ label, name, value, onChange, showEye, disabled }: InputPasswordProps) => {
  const [inputTypeText, setInputTypeText] = useState<boolean>(false)

  const toogleInputType = () => {
    setInputTypeText(!inputTypeText)
  }

  return (<>
    <div className="input-password-box">
      <label className='input-password__label'>
        {label}
      </label>
      <div className='input-password__field'>
        <input
          type={inputTypeText ? 'text' : 'password'}
          value={value}
          name={name}
          onChange={onChange}
          disabled={disabled}
        />
        <span className='input-password-eye'>
          {(showEye) && (
            (inputTypeText ?
              <EyeOpenIcon onClick={toogleInputType} className='input-password-eye-open' /> :
              <EyeClosedIcon onClick={toogleInputType} className='input-password-eye-closed' />)
          )}
        </span>
      </div>
    </div>
  </>);
};

interface PasswordValidationProps {
  inputPassword: string,
  confirmPassword: string,
  checkMinLength?: boolean,
  checkHasUpperCase?: boolean,
  checkHasLowerCase?: boolean,
  checkHasNumbers?: boolean,
  checkHasSymbols?: boolean,
  minLength?: 8,
  symbols?: string[],
  setValidationSuccess: (param: any) => void
}

const PasswordValidation = ({ inputPassword, confirmPassword, setValidationSuccess, checkMinLength = true, minLength = 8,
  checkHasUpperCase = true, checkHasLowerCase = true, checkHasNumbers = true,
  checkHasSymbols = true, symbols = ['.', ',', '%', '_', '-', '$', '?', '¿', '!', '¡', '&', '*', '#'] }: PasswordValidationProps) => {

  const passwordMinLength = () => {
    return inputPassword.length >= minLength
  }

  const containsUpperCase = () => {
    return /[A-Z]/.test(inputPassword)
  }

  const containsLowerCase = () => {
    return /[a-z]/.test(inputPassword)
  }

  const containsNumbers = () => {
    return /[0-9]/.test(inputPassword)
  }

  const containsSymbols = () => {
    return symbols.some(char => inputPassword.includes(char))
  }

  const passwordMatchConfirm = () => {
    return (inputPassword.length > 0) && (inputPassword === confirmPassword)
  }

  const errIcon = <CircleErrorIcon className='validate-password-error-icon' />
  const okIcon = <CircleCheckIcon className='validate-password-ok-icon' />

  useEffect(() =>
    setValidationSuccess(
      (!checkMinLength ? true : passwordMinLength()) &&
      (!checkHasUpperCase ? true : containsUpperCase()) &&
      (!checkHasLowerCase ? true : containsLowerCase()) &&
      (!checkHasNumbers ? true : containsNumbers()) &&
      (!checkHasSymbols ? true : containsSymbols()) &&
      (passwordMatchConfirm)
    )
    , [inputPassword, confirmPassword])

  return (<>
    <div className='validate-password-box'>
      {checkMinLength && (
        <span className='validate-password-check-item'>
          {!passwordMinLength() ? errIcon : okIcon}
          <span>Largo mínimo de 8 caracteres</span>
        </span>

      )}
      {checkHasUpperCase && (
        <span className='validate-password-check-item'>
          {!containsUpperCase() ? errIcon : okIcon}
          <span>Al menos una mayúscula</span>
        </span>
      )}
      {checkHasLowerCase && (
        <span className='validate-password-check-item'>
          {!containsLowerCase() ? errIcon : okIcon}
          <span>Al menos una minúscula</span>
        </span>
      )}
      {checkHasNumbers && (
        <span className='validate-password-check-item'>
          {!containsNumbers() ? errIcon : okIcon}
          <span>Al menos un número</span>
        </span>
      )}
      {checkHasSymbols && (
        <span className='validate-password-check-item'>
          {!containsSymbols() ? errIcon : okIcon}
          <span>Al menos un símbolo especial</span>
        </span>
      )}
      {
        <span className='validate-password-check-item'>
          {!passwordMatchConfirm() ? errIcon : okIcon}
          <span>Las contraseñas coinciden</span>
        </span>
      }

    </div>
  </>)
}

export default InputPassword
export { PasswordValidation }
